module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset><div><label for="recipient-phone-number">'+
((__t=( i18n.tc("Recipients", "Phone:") ))==null?'':__t)+
'</label> <input maxlength="20" value="'+
((__t=( phoneNumber ))==null?'':__t)+
'" id="recipient-phone-number" type="tel" data-input="recipient-phone-number"></div><div class="input"><input id="recipient-sms-emergency-alerts" data-input="recipient-sms-emergency-alerts" type="checkbox" '+
((__t=( emergencyLevel?'checked':'' ))==null?'':__t)+
'> <label for="recipient-sms-emergency-alerts"> '+
((__t=( i18n.tc("Recipients", "Emergency alerts") ))==null?'':__t)+
'</label><p><small>'+
((__t=( i18n.tc("Recipients", "If you enable SMS alert, a fee pr. recieved SMS will apply") ))==null?'':__t)+
'</small></p></div></fieldset><fieldset class="button-wrap"><button data-click="recipient-cancel">'+
((__t=( i18n.tc("Recipients", "Cancel") ))==null?'':__t)+
'</button> <button type="submit" data-click="recipient-submit" class="primary" disabled="disabled">'+
((__t=( i18n.tc("Recipients", "Save") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
